/**
 * Firebase initialisation — kept in a single module so the app and the
 * usePushNotifications hook share one Firebase app instance.
 *
 * Only the Messaging service is imported; add other Firebase services here
 * if needed in the future (Firestore, Analytics, etc.).
 */
import { initializeApp, getApps } from 'firebase/app'
import { getMessaging } from 'firebase/messaging'

const firebaseConfig = {
  apiKey:            import.meta.env.VITE_FIREBASE_API_KEY            as string,
  authDomain:        import.meta.env.VITE_FIREBASE_AUTH_DOMAIN        as string,
  projectId:         import.meta.env.VITE_FIREBASE_PROJECT_ID         as string,
  storageBucket:     import.meta.env.VITE_FIREBASE_STORAGE_BUCKET     as string,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID as string,
  appId:             import.meta.env.VITE_FIREBASE_APP_ID             as string,
}

// Guard against double-initialisation during HMR
const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig)

/** Firebase Messaging instance — null in environments without service-worker
 *  support (e.g. Firefox private mode, Safari < 16). */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let messaging: any | null = null
try {
  if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
    messaging = getMessaging(app)
  }
} catch {
  // Messaging not supported in this browser / context
}

export { app, messaging }
